module.exports = __webpack_public_path__ + "static/media/bp.7a98e364.png";